export default "__VITE_ASSET__DJ9wxvqr__"